import React from "react";
import { useSelector } from "react-redux";
import _ from "lodash";

import { withLayout } from "../../components/layout/Layout";
import { getNoLoginPage } from "../../store/config.selectors";
import { isSSO } from "../../store/info/info.selectors";
import { CommonLogin, NoLogin, SsoLogin, useEulaDialog } from "./components";
import { AriaPageTitle } from "../../components/ariaPageTitle";
import { useSessionExpirationNotification } from "../../components/notification";

import "./LoginPage.scss";

const LoginPage = () => {
  const noLoginPage = useSelector(getNoLoginPage);
  const authSSO = useSelector(isSSO);

  useEulaDialog();
  useSessionExpirationNotification();

  return (
    <div className="login-page row">
      <AriaPageTitle pageKey="page_title_login_page" />
      {noLoginPage ? <NoLogin /> : authSSO ? <SsoLogin /> : <CommonLogin />}
    </div>
  );
};

export default _.flowRight(
  withLayout({
    showHeaderUnderline: true,
    showHelpLink: true,
    showUserInfo: false,
    showNavigation: false,
  })
)(LoginPage);
